import { Component, OnInit, OnDestroy, TemplateRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DatePipe, NgClass, NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { AppConfig } from "app/app.config";
import { NgbCalendar, NgbDatepickerConfig, NgbDateStruct, NgbModal, NgbInputDatepicker, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast } from "@ng-bootstrap/ng-bootstrap";
import { LoaderService } from "app/services/loader.service";
import { APIService } from 'app/services/api.service';
import { AuthenticationService, authUserType, reRgType } from 'app/services/auth.service';
import { Subscription } from "rxjs";
import { sideMenuItemType } from "app/components/Controls/side-menu/side-menu.component";
import { AdvisorContactComponent } from "app/modules/shared/advisor-contact.component";
import * as pako from "pako"
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { SideMenuComponent } from '../../components/Controls/side-menu/side-menu.component';
import { FormsModule } from '@angular/forms';
import { ClickStopPropagationDirective } from '../../components/Controls/click-stop-propagation.directive';
import { AdvisorContactComponent as AdvisorContactComponent_1 } from '../shared/advisor-contact.component';

type sortFieldType = 'DatePostedFull' | 'FileName' | 'FileViewTime';

type apiClientType = {
  DisplayName: string;
  NameId: string;
};

type displayDocumentType = {
  Folder: string;
  FileName: string;
  Extension: string;
  LastWriteTime: null | string;
  CreationTime: string;
  Length: number;
  FileViewTime: null | string;
  DatePostedFull: string;
  DatePostedLocal: string;
  Type: string;
  FileNameLower: string;
  IsChecked: boolean;
  IsNew: boolean;
  Tags: string[];
};

@Component({
    selector: 'nwm-document',
    templateUrl: './document.component.html',
    styleUrls: [`./document.component.scss`],
    imports: [MenuComponent, NgClass, SideMenuComponent, FormsModule, NgbInputDatepicker, NgTemplateOutlet, NgbPagination, NgbPaginationFirst, NgbPaginationPrevious, NgbPaginationNext, NgbPaginationLast, ClickStopPropagationDirective, AdvisorContactComponent_1, UpperCasePipe, DatePipe]
})

export class DocumentComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private config = inject(AppConfig);
  private loaderService = inject(LoaderService);
  private dpConfig = inject(NgbDatepickerConfig);
  private api = inject(APIService);
  auth = inject(AuthenticationService);
  private calendar = inject(NgbCalendar);
  private datePipe = inject(DatePipe);
  private modalService = inject(NgbModal);

  page = 1;
  pageSize: number = this.config.document.documentPageSize;
  pageOptions: number[] = Array.from({length: 10}, (v, k) => (k + 1) * 10);
  totalPages = 1;
  endDate: Date = new Date();
  startDate: Date = new Date(this.endDate.getFullYear() - 1, 0, 1);
  displayStartDate: string = this.printDate(this.startDate);
  displayEndDate: string = this.printDate(this.endDate);
  minDate: NgbDateStruct = {year: 2000, month: 1, day: 1};
  maxDate: NgbDateStruct = this.toDateStruct(this.endDate);
  startDateModel: NgbDateStruct = this.toDateStruct(this.startDate);
  endDateModel: NgbDateStruct = this.toDateStruct(this.endDate);

  pagedDocuments: displayDocumentType[] = [];
  filterText = '';
  curentFilterText = '';
  selectedDocumentType  = '';
  checkAllSelected = false;
  isImpersonated = false;

  user?: authUserType;
  reRg?: reRgType;

  categories_accountant: sideMenuItemType[] = [
    { canActivate: false, id: '', items: [], opened: false, title: 'All' },
    { canActivate: false, id: 'Financial Planning\\WEB Uploads', items: [], opened: false, title: 'Your Uploads' },
  ];
  categories_pgf: sideMenuItemType[] = [
    { canActivate: false, access: 'View_Documents_NWMStatements', id: 'Financial Planning\\WEB Statements', items: [], opened: false, title: 'Nicola Wealth Statements' },
    { canActivate: false, access: 'View_Documents_Charity_Communication', id: 'Financial Planning\\WEB Communication', items: [], opened: false, title: 'Charity Communication' },
    { canActivate: false, access: 'View_Documents_Tax', id: 'Financial Planning\\WEB Tax Returns & Financial Statements', items: [], opened: false, title: 'Tax Receipts' },
    { canActivate: false, access: 'View_Documents_WillTrustCorporate', id: 'Financial Planning\\WEB Wills, Trusts & Agreements', items: [], opened: false, title: 'Legal Documents' },
    { canActivate: false, access: '', id: '~CommonDocs', items: [], opened: false, title: 'Notices', clientOnly: true },
    { canActivate: false, access: 'View_Documents_Inbox', id: 'Financial Planning\\WEB Forms', items: [], opened: false, title: 'Inbox' },
    { canActivate: false, access: 'View_Documents_Uploads', id: 'Financial Planning\\WEB Uploads', items: [], opened: false, title: 'Your Uploads' },
    { canActivate: false, access: 'View_Documents_Other', id: 'Financial Planning\\WEB Other', items: [], opened: false, title: 'Other' },
  ];
  categories: sideMenuItemType[] = [
    //{ canActivate: false, id: '', items: [], opened: false, title: 'All' },
    { canActivate: false, access: 'View_Documents_NWMStatements', id: 'Financial Planning\\WEB Statements', items: [], opened: false, title: 'Nicola Wealth Statements' },
    { canActivate: false, access: 'View_Documents_Planning', id: 'Financial Planning\\WEB Planning', items: [], opened: false, title: 'Planning' },
    { canActivate: false, access: 'View_Documents_Tax', id: 'Financial Planning\\WEB Tax Returns & Financial Statements', items: [], opened: false, title: 'Tax' },
    { canActivate: false, access: 'View_Documents_WillTrustCorporate', id: 'Financial Planning\\WEB Wills, Trusts & Agreements', items: [], opened: false, title: 'Wills, Trust & Corporate' },
    { canActivate: false, access: '', id: '~CommonDocs', items: [], opened: false, title: 'Notices', clientOnly: true },
    { canActivate: false, access: 'View_Documents_Inbox', id: 'Financial Planning\\WEB Forms', items: [], opened: false, title: 'Inbox' },
    { canActivate: false, access: 'View_Documents_Uploads', id: 'Financial Planning\\WEB Uploads', items: [], opened: false, title: 'Your Uploads' },
    { canActivate: false, access: 'View_Documents_Other', id: 'Financial Planning\\WEB Other', items: [], opened: false, title: 'Other' },
  ];

  public accountantClients: sideMenuItemType[] = [];
  public accountantClientsFull: sideMenuItemType[] = [];
  public selectedClient: sideMenuItemType | undefined;

  public sortField: sortFieldType = 'DatePostedFull';
  public sortDir = 1;

  public lastViewed?: string;
  private subscription?: Subscription;

  protected _allChecked = false;
  public set allChecked(checked) {
    this.selectedCount = 0;
    this.selectedReadCount = 0;
    this._allChecked = checked;
    for (const doc of this.pagedDocuments) {
      doc.IsChecked = this._allChecked;
      if (doc.IsChecked) {
        this.selectedCount++;
        if (doc.FileViewTime === null) {
          this.selectedReadCount++;
        }
      }
    }
  }

  public get allChecked() {
    return this._allChecked;
  }

  public selectedCount = 0;
  public selectedReadCount = 0;
  public disableResetDateButton = true;
  public pageItemRange = '0';
  public isCollapse = false;
  public hasClientList = false;
  public newDocsOnly = false;
  public otherClientsHasNew = false;
  public noClientTag = '[client:none]';
  today = this.calendar.getToday();
  documentsList: displayDocumentType[] = [];
  documentsLoaded = false;
  filteredDocuments: displayDocumentType[] = [];
  modalAction:"MessageAdvisor" | "SendDocuments" = 'MessageAdvisor';
  modalTitle = '';

  async ngOnInit() {
    const f = this.route.snapshot.fragment;

    this.dpConfig.firstDayOfWeek = 7;
    this.dpConfig.markDisabled = () => {
      return false;
    };
    this.isImpersonated = !!sessionStorage.getItem('guid');

    this.loaderService.display(true, 'files');

    this.reRg = this.auth.getCurrentReRg()!;

    this.documentsLoaded = false;
    this.user = this.auth.getUser()!;
    if (this.reRg.RergType === 'PGF') {
      this.categories = this.categories_pgf.filter(c=>!c.access || this.auth.hasAccess(c.access));
    } else if (this.user.isAccountant) {
      this.categories = this.categories_accountant;
    } else if (!this.user.isClient) {
      this.categories = this.categories.filter(c=>!c.clientOnly);
    } else {
      this.categories = this.categories.filter(c=>!c.access || this.auth.hasAccess(c.access));
    }

    this.selectedDocumentType = this.categories[0].id!;
    this.api.get(`${this.config.document.documentsLastViewed}/${this.reRg.ReRgId}`).subscribe(data => {
      if (data)
        this.lastViewed = data as string;

      if (f) {
        const found = this.categories.find(a => {
          return a.title == f
        });
        if (found) this.selectedDocumentType = found.id!;
      }

      this.getDocuments();
    });

  }

  getDocuments() {
    this.api.getDocumentsList(this.reRg!.ReRgId).subscribe(
      res => {
        this.loaderService.display(false, 'files');
        let mindate = '9999-99-99';
        const documents: displayDocumentType[] = [];
        res.forEach(f=>{
          if (f.DatePostedLocal < mindate) mindate = f.DatePostedLocal;
          f.Tags.push(this.noClientTag);
          const is_new = !!(f.FileViewTime === null && this.lastViewed && this.lastViewed < f.DatePostedFull);
          documents.push({
            ...f,
            IsNew: is_new,
            IsChecked: false
          });
          if (is_new) {
            const category = this.categories.find(c=>c.id === f.Folder);
            if (category) {
              category.hasNew = true;
            }
          }

        });
        if (mindate != '9999-99-99') {
          const d = mindate.split('-');
          this.minDate = {year:+d[0], month:+d[1], day:+d[2]};
          this.startDate = new Date(mindate+'T00:00:00');
          this.startDateModel = this.minDate;
        }

        this.documentsList = documents;
        this.filterDocuments();

        if (this.user!.isAccountant) {
          this.getAccountantClients();
        }
        this.documentsLoaded = true;

      },
      () => this.loaderService.display(false, 'files')
    );
  }

  documentUploaded() {
    this.api.clearDocumentsCache();
    this.selectedDocumentType = 'Financial Planning\\WEB Uploads';
    this.getDocuments();
  }

  newDocsOnlyChange() {
    this.accountantClients = this.newDocsOnly ? this.accountantClientsFull.filter(c=>c.class==='hasNew') : this.accountantClientsFull;
    this.clearTextFilter();
  }

  getAccountantClients() {
    this.loaderService.display(true, 'clients');
    this.accountantClients = [];
    this.hasClientList = false;

    (this.api.get<apiClientType[]>(`${this.config.advisor.getLinkedClients}/${this.reRg!.ReRgId}`))
    .subscribe(
      data => {
        if (data) {
          data.forEach(c => {
            const dn = c.DisplayName.replace(/[\s,]+$/gm,'');
            if (this.accountantClients.some(c=>c.id===dn)) return; //skip duplicate client names

            const tags = dn.toLowerCase().split(/[^a-z0-9]+/).filter((v,i,a)=>v!=='' && a.indexOf(v) === i);
            let hasNewDocs = false;
            this.documentsList.forEach(f => {
              if (tags.every(t=>f.Tags.includes(t))) {
                const ind = f.Tags.indexOf(this.noClientTag);
                if (ind > -1) f.Tags.splice(ind,1);
                hasNewDocs = hasNewDocs || f.IsNew;
              }
            })

            this.accountantClients.push({ canActivate: true, id: dn, items: [], opened: false, title: dn, class:hasNewDocs?'hasNew':'' });
          });
        }
        this.documentsList.some(f => {
          if (f.Tags.includes(this.noClientTag) && f.IsNew) {
            this.otherClientsHasNew = true;
            return true;
          }
          return false;
        })
        this.accountantClientsFull = this.accountantClients;
        this.hasClientList = this.accountantClients.length > 0;
        this.loaderService.display(false, 'clients');
      },
      () => this.loaderService.display(false, 'clients')
    );
  }

  clearTextFilter() {
    this.curentFilterText = this.filterText = '';
    this.filterDocuments();
  }

  filterDocuments() {
    const startDate = this.startDateModel ?
      this.startDateModel.year + '-' + ("0" + this.startDateModel.month).slice(-2) + '-' + ("0" + this.startDateModel.day).slice(-2)
      : null;
    const endDate = this.endDateModel ?
      this.endDateModel.year + '-' + ("0" + this.endDateModel.month).slice(-2) + '-' + ("0" + this.endDateModel.day).slice(-2)
      : null;
    this.curentFilterText = this.filterText;
    let text = this.filterText.toLowerCase();
    let tags:string[] = [];
    if (text.includes(this.noClientTag)) {
      tags.push(this.noClientTag);
      text = text.replace(this.noClientTag,'').trim();
    }

    tags = tags.concat(text.split(/[^a-z0-9]+/).filter((v,i,a)=>v!=='' && a.indexOf(v) === i));
    const wordsCount = tags.filter(t=>t!==this.noClientTag).length;

    this.filteredDocuments = this.documentsList.filter(f=>
      (!this.selectedDocumentType || f.Folder === this.selectedDocumentType)
      && (!startDate || f.DatePostedLocal >= startDate)
      && (!endDate || f.DatePostedLocal <= endDate)
      && (!this.newDocsOnly || f.IsNew)
      && (!tags.includes(this.noClientTag) || f.Tags.includes(this.noClientTag))
      && (wordsCount!==1 || f.FileNameLower.includes(text))
      && (wordsCount < 2 || tags.every(t=>f.Tags.includes(t)))
    )
    this.sortDocuments();
    return true;
  }

  toggleSort(field: sortFieldType = 'FileName') {
    if (this.sortField == field) {
      this.sortDir = 0-this.sortDir;
    } else {
      this.sortField = field;
      this.sortDir = 1;
    }
    this.sortDocuments();
  }

  sortDocuments() {
    if (this.sortField == 'FileName') {
      this.filteredDocuments.sort((a,b)=>
          a['FileName'].localeCompare(b['FileName'])*this.sortDir
      )
    } else {
      this.filteredDocuments.sort((a,b)=>
          (a[this.sortField] || '') > (b[this.sortField] || '') ? 0-this.sortDir :
          (a[this.sortField] || '') < (b[this.sortField] || '') ? this.sortDir :
          a['FileName'].localeCompare(b['FileName'])
      )
    }
    this.setPage(1);
  }

  setPage(page: null | number = null) {
    this.selectedCount = 0;
    this.selectedReadCount = 0;
    this._allChecked=false;
    this.documentsList.forEach(d=>{d.IsChecked = false});

    if (page) this.page = page > 0 ? +page : 1;
    const l = this.filteredDocuments.length;
    const p = this.pageSize>0 ? +this.pageSize : l;
    if (p<l) {
      this.totalPages = p ? Math.ceil(l / p) : 1;
      if (this.totalPages < this.page) this.page = this.totalPages;
      const s = (this.page-1) * p;
      const e = s+p > l ? l : s+p;
      this.pagedDocuments = this.filteredDocuments.slice(s, e);
      this.pageItemRange = s+' to '+e;
    } else {
      this.totalPages = 1;
      this.pagedDocuments = this.filteredDocuments;
      this.pageItemRange = ''+l;
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  selectDocType(type: string) {
    this.selectedDocumentType = type;
    this.filterDocuments();
  }

  downloadSelected() {
    const docs: displayDocumentType[] = [];

    this.pagedDocuments.forEach(d=>{
      if (d.IsChecked) docs.push(d);
    });

    if (docs.length > 0) {
      this.downloadFiles(docs);
    }
  }

  downloadFiles(docs: displayDocumentType[]) {
    if (!docs) return;
    const documentDownload: string[][] = [];
    docs.forEach(d=>{
      documentDownload.push([d.Folder,d.FileName]);
    });

    const q = this.gzipAndBase64Encode(JSON.stringify(documentDownload));
    this.openFile(q, this.reRg!.ReRgId);
    if (!this.isImpersonated) {
      const now = this.datePipe.transform(new Date, 'yyyy-MM-ddTHH:mm:ss.SSSZZZZZ'); //ISO 8601 Date and time with the offset
      docs.forEach(d => {
        d.FileViewTime = now;
        d.IsChecked = false;
        d.IsNew = false;
      });
      this.selectedCount = 0;
      this.selectedReadCount = 0;
      this._allChecked = false;
    }
  }

  changeClient(search: string) {
    this.filterText = search;
    this.filterDocuments();
    return true;
  }

  previewFile(evt: Event, doc: displayDocumentType) {
    if (!doc) return;
    const q = this.gzipAndBase64Encode(JSON.stringify([[doc.Folder,doc.FileName]]));
    this.openFile(q, this.reRg!.ReRgId, true);
    if (!this.isImpersonated) {
      doc.FileViewTime = this.datePipe.transform(new Date, 'yyyy-MM-ddTHH:mm:ss.SSSZZZZZ'); //ISO 8601 Date and time with the offset
      doc.IsNew = false;
    }
  }

  openFile(q: string, rergId: number, preview = false) {
    const role = this.user?.isAccountant ? 'Accountant' : (this.reRg?.RergType === 'Prospect' ? 'Prospect' : 'Client');
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = this.config.document.documentReadUrl+'?q='+encodeURIComponent(q)+'&u='+this.user?.uId+'&reRgId='+rergId+'&role='+role+(preview ? '&preview=true' : '');
    a.target = "_blank";
    a.click();
    a.remove();
    if (!this.isImpersonated) this.api.clearDocumentsCache(); // without cache reset if user leaves docs page then comes back, the FileViewTime will be loaded from cache which we don't want
  }

  /**
   * it would open a modal to send message & upload documents to the team
   * @param modal
   */
  openModalToUploadDocuments(modal: TemplateRef<AdvisorContactComponent>) {
    this.modalAction = 'SendDocuments';
    this.modalTitle = 'Upload Document';
    this.modalService.open(modal, { size: 'lg' })
  }

  openContactUsModal(modal: TemplateRef<AdvisorContactComponent>) {
    this.modalAction = 'MessageAdvisor';
    this.modalTitle = 'Contact Us';
    this.modalService.open(modal, { size: 'lg' })
  }

  clearFilter(): void {
    this.filterText = '';
    this.filterDocuments();
  }

  printDate(date: Date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  }

  toDateStruct(date: Date) {
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  }

  checkDisableResetDate() {
    const startDateStruct = this.toDateStruct(this.startDate);
    const endDateStruct = this.toDateStruct(this.endDate);

    return (
      startDateStruct.day === this.startDateModel.day &&
      startDateStruct.month === this.startDateModel.month &&
      startDateStruct.year === this.startDateModel.year
    ) && (
      endDateStruct.day === this.endDateModel.day &&
      endDateStruct.month === this.endDateModel.month &&
      endDateStruct.year === this.endDateModel.year
    );
  }

  resetDates() {
    this.startDateModel = this.toDateStruct(this.startDate);
    this.endDateModel = this.toDateStruct(this.endDate);
    this.dateChange();
  }

  verifyAllChecked() {
    this.selectedCount = 0;
    this.selectedReadCount = 0;

    const r = this.pagedDocuments.reduce((r, doc) => {
      if (doc.IsChecked) {
        this.selectedCount++;
        if (doc.FileViewTime === null) {
          this.selectedReadCount++;
        }
      } return r && doc.IsChecked; }, true);

    if (r) {
      this._allChecked = true;
    } else if (this.allChecked) {
      this._allChecked = false;
    }
  }

  dateChange() {
    this.disableResetDateButton = this.checkDisableResetDate();
    this.filterDocuments();
  }

  /**
   * It would compress the specified string & then convert it to base64
   * The filenames are sent via GET request, so we need to decrease its size by compressing it.
   * @param input
   */
  gzipAndBase64Encode(input: string): string {
    const encoder = new TextEncoder();
    const inputBytes = encoder.encode(input);
    const compressedData: Uint8Array = pako.gzip(inputBytes);
    return window.btoa(String.fromCharCode(...compressedData));
  }
}
